import * as z from 'zod';

import { LosId, PropertyId } from '../../BrandedIds';
import { zodBrandedString, zodDateOrString } from '../../utils/Zod';
import { NonNegativeMonetaryValue } from '../../validations/fields';
import { ExportableAddress } from '../util/ExportableAddress';

export type ExportablePropertyFlood = z.infer<typeof ExportablePropertyFlood>;
export const ExportablePropertyFlood = z.object({
  zone: z.string().optional(),
  zoneFlag: z.boolean().optional(),
  partialZoneIndicator: z.string().optional(),
  contractType: z.string().optional(),
  contractNumber: z.string().optional(),
  program: z.string().optional(),
  nfipDateRevisionType: z.string().optional(),
  nfipCommunityIdentifier: z.string().optional(),
  nfipMapIdentifier: z.string().optional(),
  nfipMapPanelDate: zodDateOrString.optional(),
  certificateProviderName: z.string().optional(),
  certificateNumber: z.string().optional(),
  determinationDate: zodDateOrString.optional(),
});

/**
 * Contracts that will be transferred to the next servicer
 */
export type ExportableTransferableMonitoringContracts = z.infer<typeof ExportableTransferableMonitoringContracts>;
export const ExportableTransferableMonitoringContracts = z.object({
  flood: z.boolean().optional(),
  tax: z.boolean().optional(),
});

export type ExportableProperty = z.infer<typeof ExportableProperty>;
export const ExportableProperty = z
  .object({
    id: zodBrandedString<PropertyId>(),
    loanId: zodBrandedString<LosId>(),
    address: ExportableAddress,
    isReleased: z.boolean(),
    coverageAmount: NonNegativeMonetaryValue.optional(),
    replacementCostValue: NonNegativeMonetaryValue.optional(),
    propertyType: z.string().optional(),
    propertySubType: z.string().optional(),
    flood: ExportablePropertyFlood.optional(),
    purchasePrice: NonNegativeMonetaryValue.optional(),
    numberOfUnits: z.number().positive().int().optional(),
    propertyValuationMethodType: z.string().optional(),
    transferableMonitoringContracts: ExportableTransferableMonitoringContracts.optional(),
  })
  .meta({ title: 'Property' });
